<template>
  <b-input-group>
    <b-input-group-prepend>
      <span class="input-group-text">
        <i class="mdi mdi-power-socket text-primary"></i>
      </span>
      <b-btn class="quantity-button" variant="outline-primary" @click="decrement()">-</b-btn>
    </b-input-group-prepend>

    <b-form-input
      :id="id"
      v-model="quantity"
      :name="name"
      class="quantity-input"
      type="number"
      :min="min"
    ></b-form-input>
    <b-input-group-append>
      <b-btn
        class="quantity-button quantity-button-right"
        variant="outline-primary"
        @click="increment()"
      >
        +
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>
<script>
export default {
  name: 'Quantity',
  props: {
    min: {
      required: false,
      type: String,
      default: '0',
    },
    step: {
      required: false,
      type: String,
      default: '1',
    },
    id: { required: false, type: String },
    name: { required: false, type: String },
    value: { required: true },
  },
  computed: {
    quantity: {
      get: function () {
        return this.value;
      },
      set: function (v) {
        this.$emit('input', v);
      },
    },
    numberStep() {
      let step = Number(this.step);

      if (isNaN(step)) {
        return 0;
      }

      return step;
    },
    countDecimalsStep() {
      if (Math.floor(this.step) !== this.step) {
        return this.step.split('.')[1].length || 0;
      }
      return 0;
    },
  },
  methods: {
    increment() {
      this.quantity = (Number(this.quantity) + this.numberStep).toFixed(this.countDecimalsStep);
    },
    decrement() {
      if (this.quantity >= this.numberStep) {
        this.quantity = (Number(this.quantity) - this.numberStep).toFixed(this.countDecimalsStep);
      }
    },
  },
};
</script>

<style>
.quantity-input {
  text-align: center;
}

.quantity-button {
  width: 35px;
  border-radius: inherit;
}
</style>
>
